import { __extends } from "tslib";
import { BaseApi } from '../BaseApi';
import { query as getProductQuery } from '../../graphql/getProduct.graphql';
import { GraphQLOperations, RemoteSourceTypes } from '../constants';
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductsApi.prototype.fetchProductSlug = function (productId) {
        return this.fetch({
            variables: { productId: productId },
            operationName: GraphQLOperations.GetProduct,
            query: getProductQuery,
        }, RemoteSourceTypes.ScalaReadOnly).then(function (response) { return response.data.catalog.product; });
    };
    return ProductsApi;
}(BaseApi));
export { ProductsApi };
//# sourceMappingURL=ProductsApi.js.map